import { useMemo } from 'react';
import { Group } from 'react-konva';
import Cell from './Cell';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { UseCellSelection } from '../../../hooks/useCellSelection';
import { UseGridOperations } from '../../../hooks/useGridOperations';
import { getColumnsCellView } from '../../../helpers/cellView/cellColumns';
import {
  ColumnCellView,
  RowCellView,
} from '../../../helpers/cellView/cellViewTypes';
import { getRowsCellView } from '../../../helpers/cellView/cellRows';
import { UseKonvaCursor } from '../../../../core/hooks/useKonvaCursor';

interface CellsPaneProps
  extends ReturnTypeofSheetSectionsSelector,
    UseKonvaCursor,
    Pick<UseCellSelection, 'onCellMouseDown' | 'onCellMouseHover'>,
    Pick<
      UseSheetTheme,
      'fill' | 'stroke' | 'textColor' | 'isRtl' | 'isDarkTheme'
    >,
    Pick<UseGridOperations, 'performSheetOperation'> {
  sheetId: string;
  gridWidth: number;
}
const CellsPane: React.FC<CellsPaneProps> = (props) => {
  const {
    gridWidth,
    sheetId,

    fill,
    textColor,
    stroke,
    isRtl,

    rowViewport,
    colViewport,

    onCellMouseDown,
    onCellMouseHover,
    performSheetOperation,
    onMouseEnter,
    onMouseLeave,
  } = props;

  const renderCell = (params: RowCellView): JSX.Element => {
    if (
      params.ci == undefined ||
      // params.colId === undefined ||
      params.x === undefined ||
      params.width === undefined
    )
      return <></>;

    const frozen = params.frozenColumn || params.frozenRow;

    const {
      x,
      y,
      width,
      height,
      ci,
      ri,
      style,
      numberFormat,
      dataValidation,
      // cellArea,
    } = params;

    return (
      <Cell
        sheetId={sheetId}
        key={`${sheetId}-${ci}-${ri}`}
        x={x}
        y={y}
        width={width}
        height={height}
        // rowId={params.rowId}
        ri={ri}
        ci={ci}
        // actualRowIndex={params.actualRowIndex}
        // colId={params.colId}
        isError={!!params.isError}
        cellValue={params.value ?? ''}
        zoom={props.zoom}
        frozen={frozen}
        isRtl={props.isRtl}
        // fill={fill}
        // textColor={textColor}
        isDarkTheme={props.isDarkTheme}
        stroke={stroke}
        {...style?.font}
        {...style?.fill}
        {...style?.alignment}
        // horizontal={params.horizontal}
        // color={params.color}
        // {...style?.border}
        // textWrap={style?.textWrap}
        // rotation={style?.rotation}
        numberFormatType={numberFormat?.type}
        numberFormatCode={numberFormat?.code}
        onCellMouseDown={onCellMouseDown}
        onCellMouseHover={onCellMouseHover}
        performSheetOperation={performSheetOperation}
        dataValidation={dataValidation}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  };

  const startRenderCell = (params: ColumnCellView) =>
    getRowsCellView(props, renderCell, {}, params);

  const Cells = useMemo(
    () =>
      getColumnsCellView(props, startRenderCell, {
        areEditableCells: true,
      }),
    [
      props.isDarkTheme,
      isRtl,
      gridWidth,
      sheetId,
      rowViewport,
      colViewport,
      onCellMouseDown,
      onCellMouseHover,
      performSheetOperation,
    ]
  );

  return <Group>{Cells}</Group>;
};

export default CellsPane;
